import styled from "styled-components";
import { FaCheck } from "react-icons/fa6";
import { MdClose } from "react-icons/md";

export const Icons = styled.div`
  display: flex;
  gap: 1rem;
`;

export const CheckIcon = styled(FaCheck)`
  height: 1.5rem;
  width: 1.5rem;
  color: white;
  background-color: rgb(63, 237, 84);
  padding: 4px;
  border-radius: 3px;
  cursor: pointer;
`;

export const CloseIcon = styled(MdClose)`
  height: 1.5rem;
  width: 1.5rem;
  color: white;
  background-color: rgb(249, 74, 74);
  padding: 3px;
  border-radius: 3px;
  cursor: pointer;
`;

export const ImageLink = styled.a`
  text-decoration: none;
  color: black;
  font-weight: bold;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  color: rgb(10 92 86);
  padding: 2rem;
  border-radius: 8px;
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const ModalTitle = styled.h2`
  font-size: 1.2rem;
  text-align: center;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.8rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  outline: none;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 8px;
`;

export const CancelButton = styled.button`
  width: 25%;
  background: #ccc;
  color: #000;
  padding: 0.7rem;
  border-radius: 4px;
  border: none;
  cursor: pointer;

  &:hover{
    background-color: #b6b6b6ff;
  }
`;

export const ConfirmButton = styled.button`
  width: 25%;
  background: #e74c3c;
  color: #fff;
  padding: 0.7rem;
  border-radius: 4px;
  border: none;
  cursor: pointer;

    &:hover{
    background-color: #b63c2fff;
  }
`;
export const TablePopup = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 12rem;
`;
